// extracted by mini-css-extract-plugin
module.exports = {"scheduledSettingsTab":"ScheduledSettingsTab_scheduledSettingsTab__2KA-Q","tabHeader":"ScheduledSettingsTab_tabHeader__2-KG_"};